module.exports = __webpack_public_path__ + "static/media/pin_drop_FILL0_red.4a4c8b03.svg";